import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { GradeLevelsSection } from './components/GradeLevelsSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    document.title = 'THE COMPLETE ART YEAR™';
  }, []);
  return <div className="w-full bg-navy text-white" data-id="element-0" data-mp="3rbrakqf99zft">
      <StickyHeader data-id="element-1" data-mp="3rd1a7k1rbfok" />
      <main data-id="element-2" data-mp="3relw6la09qat">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="5ot150vj28n" />
        <Hero data-id="element-4" data-mp="5ghbgghm2z1" />
        <SocialProofBar data-id="element-5" data-mp="82kl3wchwbg" />
        <PainSection data-id="element-6" data-mp="2zld1d7i6tbah" />
        <ProductIntro data-id="element-7" data-mp="2zlv84y2h77wn" />
        <VolumesSection data-id="element-8" data-mp="2zmem63p09c5e" />
        <BonusesSection data-id="element-9" data-mp="2zn6cayzu2hoa" />
        <ValueStack data-id="element-10" data-mp="33mf2jtvnzxf3" />
        <GradeLevelsSection data-id="element-11" data-mp="33lx02fiesmyq" />
        <Testimonials data-id="element-12" data-mp="33n6wz1dizp3s" />
        <HowItWorks data-id="element-13" data-mp="33oi2b5mmd4x0" />
        <Guarantee data-id="element-14" data-mp="38m1e7yvuh5ls" />
        <ClosingBlock data-id="element-15" data-mp="38li6tc3tlzm0" />
        <FAQ data-id="element-16" data-mp="38k6ugnwb7jja" />
      </main>
      <Footer data-id="element-17" data-mp="38o4gbha9up6v" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-18" data-mp="3dkuvm2e95gr8" />
      {showPurchaseNotifications && <SocialProofPopup data-id="element-19" data-mp="nvj4pj9gikrb" />}
      <FloatingCTA data-id="element-20" data-mp="nw2egcoye2u9" />
    </div>;
}